import React, { Fragment } from 'react'
import styled from 'styled-components'

import refractor from 'refractor/core'
import { RefractorAutoDetect } from 'cg/components/shared/refractor/refractorAutoDetect'
import { mapWithDepth } from 'cg/components/shared/refractor/refractorUtils'
import { Link } from 'react-router-dom'

const OPENING_ES_TAG = '<eshighlight>'
const CLOSING_ES_TAG = '</eshighlight>'
const REPLACEMENT_OPENING_ES_TAG = '<mark>'
const REPLACEMENT_CLOSING_ES_TAG = '</mark>'

const Result = ({ hit, setShowSearchModal }) => {
  let link = `${hit.source.publish_link}`
  link = hit.source.uuid ? `${link}#${hit.source.uuid}` : link

  const generateDisplayLink = source => {
    if (source.document_title) {
      const document_title = source.document_section_group_path
        ? `${source.document_section_group_path}/${source.section_title ? source.section_title : source.title}`
        : source.section_title
          ? source.section_title
          : source.title
      if (source.document_version_title) {
        return `${source.document_title}/${source.document_version_title}/${document_title}`
      }

      return `${source.document_title}/${document_title}`
    }
    return `${source.title}`
  }

  const santizeElasticSearchTags = value => {
    let parsedValue = value.replaceAll(OPENING_ES_TAG, REPLACEMENT_OPENING_ES_TAG)
    parsedValue = parsedValue.replaceAll(CLOSING_ES_TAG, REPLACEMENT_CLOSING_ES_TAG)

    return parsedValue
  }

  const stripElasticSearchTags = value => {
    let parsedValue = value.replaceAll(OPENING_ES_TAG, '')
    parsedValue = parsedValue.replaceAll(CLOSING_ES_TAG, '')

    return parsedValue
  }

  const parseValue = value => {
    let html = ''
    for (const line of value) {
      html += `<div>${santizeElasticSearchTags(line)}</div>`
    }
    return { __html: html }
  }

  const renderKeyValue = (key, value) => (
    <>
      <HighlightKey key={key}>{key && <span>{key}:</span>}</HighlightKey>
      <HighlightValue dangerouslySetInnerHTML={parseValue(value)} />
    </>
  )

  const parseBlob = value => {
    let html = ''
    for (const line of value) {
      html += `${line}\n`
    }
    return html
  }

  const highlightBlob = (language, value) => {
    let highlightedHtml = ''
    const matches = value.split(/(<eshighlight>.*?<\/eshighlight>)/g)

    for (const match of matches) {
      if (match.includes(OPENING_ES_TAG)) {
        highlightedHtml += `${REPLACEMENT_OPENING_ES_TAG}`
        const strippedMatch = stripElasticSearchTags(match)
        const ast = refractor.highlight(strippedMatch, language)
        const value = ast.length === 0 ? strippedMatch : ast.map(mapWithDepth(0)).join('')
        highlightedHtml += value
        highlightedHtml += `${REPLACEMENT_CLOSING_ES_TAG}`
      } else {
        const ast = refractor.highlight(match, language)
        const value = ast.length === 0 ? match : ast.map(mapWithDepth(0)).join('')
        highlightedHtml += value
      }
    }

    return highlightedHtml
  }

  const renderBlob = (title, value, languageOverride = null) => {
    const language = languageOverride || new RefractorAutoDetect().getFileMode(title.replace(/^.*(\\|\/|:)/, ''))

    if (language && !refractor?.registered(language)) {
      try {
        refractor.register(require(`refractor/lang/${language}.js`))
      } catch (err) {}
    }

    const parsedValue = parseBlob(value)

    const highlightedValue = language ? highlightBlob(language, parsedValue) : santizeElasticSearchTags(parsedValue)
    return <PRE dangerouslySetInnerHTML={{ __html: highlightedValue }} />
  }

  return (
    <ResultWrapper className="result">
      <ResultLink>
        <Link
          to={link}
          onClick={e => {
            setShowSearchModal(false)
          }}
        >
          {generateDisplayLink(hit.source)}
        </Link>
      </ResultLink>
      {Object.keys(hit.highlight).map((key, index) => (
        <HighlightWrapper key={key}>
          {key === 'content' && hit && hit.source && hit.source.language && hit.source.language.length
            ? renderBlob(
                hit && hit.source && hit.highlight && hit.source.title,
                hit.highlight[key],
                hit.source.uuid && hit.source.uuid.length && hit.source.language && hit.source.language.length
                  ? hit.source.language
                  : null
              )
            : renderKeyValue(
                hit && hit.source && hit.source.uuid && hit.source.uuid.length ? '' : key,
                hit.highlight[key],
                hit.highlight[key]
              )}
        </HighlightWrapper>
      ))}
    </ResultWrapper>
  )
}

export default Result

const ResultLink = styled.div`
  margin-bottom: 10px;
  word-break: break-word;
  word-wrap: break-word;
`
const ResultWrapper = styled.div`
  padding: 16px 8px;
  border-bottom: 0.0625rem solid ${props => props.theme.borderColor};
  color: ${props => props.theme.textGreyTinted};
  word-break: break-all;
`
const HighlightWrapper = styled.div`
  display: flex;
`
const HighlightKey = styled.div`
  font-weight: 500;
  font-size: 14.5px;
  margin-right: 2.5px;
`
const HighlightValue = styled.div`
  font-size: 14.5px;
  .mark,
  mark {
    padding: 0.2em;
    background-color: ${props => props.theme.mark};
  }
`
const PRE = styled.pre`
  background: ${props => props.theme.modalSplitNavBg};
  padding: 12px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 13px;
  flex: 1;
  white-space: pre-wrap;
`
